import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {PlanningViewSettingsModel} from "../../models/planning-view-settings.model";

export class PlanningDraftRoutesSettingsPanelComponent implements IController {

  showRoutes?: boolean;
  showStops?: boolean;
  settings: PlanningViewSettingsModel;
  onSettingsChange: Function;

  constructor(private $mdPanel) {

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_START,
        this.$mdPanel.yPosition.BELOW // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.show-button')
      .withAnimation(this.$mdPanel.animation.FADE);

    const settingsRef = this.settings;
    const showRoutesRef = this.showRoutes;
    const showStopsRef = this.showStops;

    const config = {
      attachTo: angular.element(document.body),
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      template: '<planning-draft-routes-settings-panel-template ' +
        'panel-ref="ctrl.mdPanelRef" settings="ctrl.settings" show-routes="ctrl.showRoutes" show-stops="ctrl.showStops">' +
        '</planning-draft-routes-settings-panel-template>',
      controller: function () {
        this.settings = settingsRef;
        this.showRoutes = showRoutesRef;
        this.showStops = showStopsRef;
      },
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: (panel, reason, updatedSettings) => {

        if (_.isEqual(reason, 'Submit')) {
          this.onSubmit(updatedSettings);
        }

        if (_.isEqual(reason, 'Reset')) {
          this.onReset();
        }

        if (_.isEqual(reason, 'Cancel')) {
          this.onReset();
        }

        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(settingsConfig) {
    this.onSettingsChange({
      settings: settingsConfig
    })
  }

  onSubmit(settings) {
    this.onSettingsChange({settings: settings});
  }

  onReset() {
    // const settingsConfig = this.splitService.getSiteAgentsSettings(this.splitService.getSiteId());
    // this.onSettingsChange({settings: settingsConfig});
  }

  onCancel() {
    this.onSettingsChange({settings: this.settings});
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDraftRoutesSettingsPanel', {
    bindings: {
      showRoutes: '<?',
      showStops: '<',
      settings: '<',
      onSettingsChange: '&'
    },
    template: require('./planning-draft-routes-settings-panel.html').default,
    controller: PlanningDraftRoutesSettingsPanelComponent
  });
